/* template */
<template><div class="container"><div class="choosed"><span>已选：</span><mpx-view v-for="(item, index) in (citys)" :key="item.index" @tap="onDelete(item)" class="choosed-item">{{item.city_name}}<img src="https://ut-static.udache.com/webx/sfc/zDAAD6_KoVVbL7DpWKbcG.png" class="close-icon"/></mpx-view></div><div class="btns"><mpx-view @tap="onCancel" class="btns-item">取消</mpx-view><mpx-view @tap="onConfirm" class="btns-item">确定</mpx-view></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m7d08e0ed"}'>
.container
  border-top 1px solid #eee
  width 100%
  padding 8px 20px 0
  background-color #fff
  .choosed
    display flex
    align-items center
    justify-content flex-start
    flex-wrap wrap
    color #333
    font-size 13px
    font-weight 500
    &-item
      color #000
      margin 4px 0
      font-weight 400
      background #F6F7F8
      border-radius 6px
      padding 6px 12px
      display flex
      align-items center
      margin-right 8px
      &:last-child
        margin-right 0
.btns
  padding 8px 0 34px
  box-sizing border-box
  display flex
  align-items center
  justify-content space-between
  &-item
    flex 1
    height 50px
    box-sizing border-box
    display flex
    align-items center
    justify-content center
    background #FF6400
    font-family PingFang SC
    font-weight 600
    font-size 16px
    color #fff
    border-radius 10px
    &:first-child
      margin-right 8px
      color #333
      background-color #fff
      border 1px solid #CCCCCC
.close-icon
  height 12px
  width 12px
  margin-left 4px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7d08e0ed"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./choosed-city.mpx.js?isComponent&outputPath=components%2Fchoosed-city7d08e0ed%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./choosed-city.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fchoosed-city7d08e0ed%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7d08e0ed"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/choosed-city7d08e0ed/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
